import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph, RoboyuOffer} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'
import {GiftShopNewYuserNoticeModalProps} from './GiftShopNewYuserNoticeModalProps'

const StyledModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  z-index: 5;
  width: 100%;
  max-width: ${convertUnit(295)};
  padding: ${convertUnit(20)};
`

const StyledText = styled(Paragraph)`
  text-align: center;
  margin-top: ${convertUnit(12)};
`

const StyledButton = styled(Button)`
  flex: 1;
  margin-top: ${convertUnit(20)};
`

const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const StyledStepNumber = styled(Paragraph)`
  position: absolute;
  bottom: ${convertUnit(-40)};
  left: 0;
  right: 0;
  text-align: center;
`

export default function GiftShopNewYuserNoticeModal({
  showStep,
  confirmText,
  onConfirm,
}: GiftShopNewYuserNoticeModalProps) {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')

  return (
    <StyledModal visible onBackdropPress={onConfirm}>
      <StyledImageContainer>
        <RoboyuOffer
          width={convertUnit(120)}
          height={convertUnit(120)}
          colorTheme={colorTheme.name}
        />
      </StyledImageContainer>
      <StyledText fontWeight="bold" fontSize="xl" lineHeight={42}>
        {translate('giftShop:newYuserNoticeTitle')}
      </StyledText>
      <StyledText fontSize="l" lineHeight={31}>
        {translate('giftShop:newYuserNoticeDescriptionFirst')}
      </StyledText>
      <StyledText fontWeight="medium" fontSize="l" lineHeight={31}>
        {translate('giftShop:newYuserNoticeDescriptionSecond')}
      </StyledText>
      <StyledText fontSize="l" lineHeight={31}>
        {translate('giftShop:newYuserNoticeDescriptionThird')}
      </StyledText>
      <StyledButton
        label={confirmText || translate('global:ok')}
        onClick={onConfirm}
      />
      {showStep && (
        <StyledStepNumber fontSize="l" fontWeight="bold" color="white_1">
          {translate('giftShop:xOfy', {x: 1, y: 2})}
        </StyledStepNumber>
      )}
    </StyledModal>
  )
}
